/**
 * @fileoverview Agent definition for story-beyond-suggester-v2.
 *
 * Suggests three distinct options for continuing the story BEYOND its
 * planned ending — sequel directions, epilogue arcs, or new narrative
 * phases that extend the story's world and characters.
 *
 * This agent treats the full plot outline as the completed narrative
 * and proposes what comes after.
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'story-beyond-suggester-v2',
  kind: 'primitive',
  name: 'Story Beyond Suggester',
  description: 'Suggests three distinct options for continuing the story beyond its planned ending, such as sequel directions or new narrative phases.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: [
      'primitives/use-story-beyond-suggester-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'sequel-ideas-generator-v2',
      'plot-snapshotter-v2',
    ],
  },
};
